import { render, staticRenderFns } from "./ItemTypeTree.vue?vue&type=template&id=56818b84&scoped=true"
import script from "./ItemTypeTree.vue?vue&type=script&lang=ts"
export * from "./ItemTypeTree.vue?vue&type=script&lang=ts"
import style0 from "./ItemTypeTree.vue?vue&type=style&index=0&id=56818b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56818b84",
  null
  
)

export default component.exports